export default {
  date: 'Дата',
  chooseExpDate: 'Изберете дата',
  filterExpDate: 'Филтриране по дата',
  experienceType: 'Тип',
  filterExperienceType: 'Филтриране по тип',
  experienceVibe: 'Настроение',
  filterExperienceVibe: 'Филтриране по настроение',
  search: 'Търсене',
  viewCalendar: 'Календар',
  back: 'Назад',
  previous: 'Предишен',
  next: 'Следващ',
  noExperiences: 'Няма преживявания',
  cancelChanges: 'Отмяна на промените',
  saveChanges: 'Запазване на промените',
  removeFromReservation: 'Премахване от резервацията',
  addToCart: 'Добави в количката',
  proceedToCheckout: 'Продължи към плащане',
  selectDate: 'Изберете дата',
  startDate: 'Начална дата',
  endDate: 'Крайна дата',
  submit: 'Изпрати',
  filterExperienceTypeScreenReader:
    'Използвайте тези филтри, за да стесните резултатите. Съдържанието се актуализира автоматично при избор на филтър.',
};
